import React from 'react';
import './buttonApostar.sass';

/**
 * Botón de apuestas para el hub de resultados deportivos
 * Permite a los usuarios acceder a la plataforma de apuestas correspondiente
 * 
 * @param {Object} props - Propiedades del componente
 * @param {boolean} props.isStrendus - Indica si es la plataforma Strendus (afecta el estilo)
 * @param {string} props.apostarHref - URL de destino para las apuestas
 * 
 * @returns {JSX.Element} Botón de apuestas estilizado
 */
export default function BotonApostarHub({ isStrendus, apostarHref = "" }) {
  
  /**
   * Maneja el click del botón de apuestas
   * Abre la URL en una nueva pestaña con configuraciones de seguridad
   */
  const handleClick = () => {
    if (!apostarHref) return;
    window.open(apostarHref, "_blank", "noopener,noreferrer");
  };

  // No renderizar si no hay URL de apuestas
  if (!apostarHref) return null;

  return (
    <button
      type="button"
      className={`btn-bet ${isStrendus === true ? "strendus" : "defaultCS"}`}
      onClick={handleClick}
      aria-label="Abrir plataforma de apuestas"
      title="Juega Aquí"
    >
      Juega Aquí
    </button>
  );
}